<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="退款流水"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学号">
          <el-input v-model="params.StudentNumber" size="mini" placeholder="请填写学号"/>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="params.CardNumber" size="mini" placeholder="请填写卡号"/>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" size="mini" placeholder="请填写姓名"/>
        </el-form-item>
        <el-form-item label="绑定电话">
          <el-input v-model="params.Mobile" type="number" size="mini" placeholder="请填写绑定电话"/>
        </el-form-item>
        <el-form-item label="退款类型">
          <el-select v-model="params.Reason" clearable>
            <el-option value="毕业结算"></el-option>
            <el-option value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款时间">
          <el-date-picker
            v-model="params.date"
            type="daterange"
            align="right"
            unlink-panels
            @change="setDate"
            range-separator="至"
            value-format="yyyy-MM-dd"
            size="mini"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:300px;"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="退款渠道">
          <el-select v-model="params.RefundType" clearable>
            <el-option :value="0" label="银行" />
            <el-option :value="1" label="微信充值" />
            <el-option :value="2" label="线下" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="params.Remark" size="mini" placeholder="请填写备注" clearable/>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column prop="StudentNumber" label="学号" min-width="100" />
        <el-table-column prop="" label="银行到账金额"/>
        <el-table-column prop="EndTime" label="银行到账时间" min-width="140"/>
        <el-table-column prop="" label="平台到账金额"/>
        <el-table-column prop="CreateTime" label="平台到账时间" min-width="140"/> -->
        <!-- <el-table-column type="selection" width="35"></el-table-column> :showCheckbox="true"
      :selectable="isSelectable"-->
        <el-table-column prop="SchoolName" label="学校名称" min-width="140"/>
        <el-table-column prop="StudentNumber" label="学号"/>
        <el-table-column prop="CardNumber" label="卡号" min-width="100"/>
        <el-table-column prop="FullName" label="姓名"/>
        <el-table-column prop="ContactNumber1" label="电话一" min-width="110"/>
        <el-table-column prop="Call2" label="电话二" min-width="110"/>
        <el-table-column prop="ContactNumber3" label="电话三" min-width="110"/>
        <el-table-column prop="Amount" label="退款金额" />
        <el-table-column prop="RefundTime" label="退款时间" min-width="140"/>
        <el-table-column prop="RefundType" label="退款渠道">
          <template slot-scope="{row}">
            <!-- {{row.RefundType==0?"银行":"微信充值"}} -->
            <span v-if="row.RefundType===0">银行</span>
            <span v-else-if="row.RefundType===1">微信充值</span>
            <span v-else-if="row.RefundType===2">线下</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="退款状态" align="center" width="100">
          <template slot-scope="{row}">
            <el-tag size="small" type="primary" v-if="row.Status==0">待退款</el-tag>
            <el-tag size="small" type="success" v-else-if="row.Status==1">退款成功</el-tag>
            <el-tag size="small" type="danger" v-else-if="row.Status==2">退款失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="TeacherName" label="经手人" min-width="85"/>
        <el-table-column prop="CreateTime" label="操作时间" min-width="140"/>
        <!-- <el-table-column prop="Detail" label="退款详情" min-width="140"/> -->
        <el-table-column prop="Remark" label="备注" min-width="85"/>
        <el-table-column prop="Detail" label="退款详情" min-width="140">
          <template slot-scope="{row}">
            <el-button v-if="row.RefundType===2" type="text" @click="deleteById(row.RefundFlowId)" size="medium">删除</el-button>&nbsp;
            <span>{{row.Detail}}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog3";

export default {
  mixins: [listMixin],
  components: { list,exportDialog },
  beforeMount() {
    this.schoolApi.list({ Status: 1 }).then(res => {
      if(res.Code == 0) {
        this.schoolList = res.Data;
        // if(res.Data.length>0) {
        //   this.params.SchoolId = res.Data[0].SchoolId;
        // }
      }
    })
  },
  data() {
    return {
      api: require("@/api/consume/refund").default,
      schoolApi: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        StudentNumber: "",
        CardNumber: "",
        FullName: "",
        Mobile: "",
        RefundType: null,
        CreateStartTime: this.$commonJs.getToday(),
        CreateEndTime: this.$commonJs.getToday(),
        Reason: "",
        Remark:"",
        date: [this.$commonJs.getToday(),this.$commonJs.getToday()]
      },
      schoolList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  methods: {
    setDate(date) {
      if(date) {
        this.params.CreateStartTime = date[0]
        this.params.CreateEndTime = date[1]
      } else {
        this.params.CreateStartTime = ""
        this.params.CreateEndTime = ""
      }
      this.query();
    },
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    isSelectable(row, index) {
      return row.RefundType===1;
    },
    deleteById(id) {
       this.$confirm("确认删除吗？","提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.api.delete2({Id:id}).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.query();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
      })
    }
  },
};
</script>